import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见<span className="text-primary-500">问题</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于观看体验的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full px-5 py-4 md:px-6 md:py-5 flex items-center justify-between gap-3 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                  openIndex === idx
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-64 pb-5 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}